export default "__VITE_ASSET__c21b1bcf__"